/*eslint-disable*/
import { useGet } from "./useRequest";

export const loadCountries = () => {
  const path = "/country";
  const Geo = "GEO";
  const response = useGet(path, Geo);
  return response;
};

export const loadStates = (country) => {

  const path = "/state/" + country;
  const Geo = "GEO";
  const response = useGet(path, Geo);
  return response;
};

export const loadCitiesByCountryStateCode = (country, state) => {
  const path = `/city/${country}/state?statecode=${state}`;
  const Geo = "GEO";
  const response = useGet(path, Geo);
  return response;
};


export function loadCities(state) {
  const path = "/city/" + state;
  const Geo = "GEO";
  const response = useGet(path, Geo);
  return response;
}


export function loadZipCodes(state, city) {
  const path = "/postalcode/" + state + "?placeName=" + city;
  const Geo = "GEO";
  const response = useGet(path, Geo);
  return response;
}


export function loadZipCodesByCountry(country, state, city) {
  const path = `/postalcodebycountry/${country}?stateCode=${state}&placeName=${city}`;
  const Geo = "GEO";
  const response = useGet(path, Geo);
  return response;
}

export function searchLocations(query) {
  const path = "/search?query=" + query;
  const Geo = "GEO";
  const response = useGet(path, Geo);
  return response;
}
